module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightcloud@2-1516c636f1c59dc471ee67a204ef7244.png";